export const contactUsForm = {
  default: {
    title: {
      label: 'Send us a message',
      translationKey: 'send_us_a_msg',
    },
    twoCol: false,
    hasReCAPTCHA: true,
    reCaptcha: {
      // validations: {
      //   label: 'Please confirm',
      //   translationKey: 'valid_recaptcha',
      //   icon: <IoMdCloseCircleOutline />,
      // }
    },
    fields: [
      {
        label: 'Field Label',
        translationKey: 'name_label',
        id: 'name',
        type: 'text',
        placeholder: {
          label: 'Write something',
          translationKey: 'name_placeholder',
        },
        twoCol: true,
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        placeholder: {
          label: 'Email@placeholder.com',
          translationKey: 'email_placeholder',
        },
        translationKey: 'email_label',
        twoCol: true,
      },
      {
        label: 'Field Label',
        id: 'subject',
        type: 'text',
        placeholder: {
          label: 'Write something',
          translationKey: 'subject_placeholder',
        },
        translationKey: 'subject_label',
        twoCol: true,
      },
      {
        label: 'Field Label',
        id: 'comment',
        type: 'textarea',
        placeholder: {
          label: 'Write something',
          translationKey: 'comment_placeholder',
        },
        translationKey: 'textarea_label',
        maxLength: '1000',
        twoCol: false,
      },
      {
        id: 'tnc',
        type: 'checkbox',
        required: true,
        translationKey: 'checkbox_label',
        twoCol: false,
        options: [
          {
            id: 'tnc',
            label:
              '+18 Lorem ipsum dolor sit amet consectetur. Egestas nibh ullamcorper venenatis vulputate. Sed elit diam at id feugiat orci ornare [link]',
            link: {
              url: '/privacy-policy',
              text: 'Link',
              translationKey: 'contact_checkbox',
            },
            translationKey: 'option_one_translation',
          },
        ],
      },
    ],
  },
};

export const newsLetterForm = {
  default: {
    title: {
      label: 'You get more than 405 free spins',
      translationKey: 'newsletter_form_main_text',
    },
    description: {
      label: 'Subscribe to our newsletter and get more than 405 free spins instantly.',
      translationKey: 'newsletter_form_subscribe_text',
    },
    fields: [
      {
        label: 'Name',
        id: 'name',
        type: 'text',
        translationKey: 'newsletter_form_first_name_text',
        required: true,
        placeholder: {
          label: 'John Doe',
          translationKey: 'newsletter_form_first_name_placeholder',
        },
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        translationKey: 'newsletter_form_email_text',
        required: true,
        placeholder: {
          label: 'johndoe@email.com',
          translationKey: 'newsletter_form_email_placeholder',
        },
      },
      // {
      //   label: 'Phone Number',
      //   id: 'phomeNumber',
      //   type: 'number',
      //   translationKey: 'newsletter_form_phone_text',
      //   placeholder: {
      //     label: '08XXXXXXXX',
      //     translationKey: 'newsletter_form_phone_placeholder',
      //   },
      // },
      {
        type: 'checkbox',
        id: 'checkbox',
        options: [
          {
            label:
              'By subscribing, you confirm [link] that you are over 18 years of age and that you accept our.[link] ',
            id: 'checkbox',
            type: 'checkbox',
            link: {
              url: 'https://google.com',
              text: 'Link',
              translationKey: 'link_checkbox',
            },
            required: true,
            translationKey: 'newsletter_form_privacy_text_1',
          },
        ],
      },
      {
        type: 'checkbox',
        id: 'checkbox_1',
        options: [
          {
            label: 'Test test ',
            id: 'checkbox_1',
            type: 'checkbox_1',
            translationKey: 'newsletter_form_privacy_text_1',
          },
        ],
      },
    ],
  },
  // 'ie_en': {
  //   title: {
  //     label: 'You get more than 405 free spins',
  //     translationKey: 'newsletter_mainText',
  //   },
  //   description: {
  //     label: 'Subscribe to our newsletter and get more than 405 free spins instantly.',
  //     translationKey: 'newsletter_subscribeText',
  //   },
  //   fields: [
  //     {
  //       label: 'Name',
  //       id: 'name',
  //       type: 'text',
  //       translationKey: 'newsletter_form_first_name_placeholder',
  //       required: true,
  //       placeholder: {
  //         label: 'John Doe',
  //         translationKey: 'newsletter_placeholder_name',
  //       },
  //     },
  //     {
  //       label: 'Email Address',
  //       id: 'email',
  //       type: 'email',
  //       translationKey: 'newsletter_form_email_text',
  //       required: true,
  //       placeholder: {
  //         label: 'johndoe@email.com',
  //         translationKey: 'newsletter_placeholder_email',
  //       },
  //     }
  //   ],
  // },
};
